export default __webpack_public_path__ + "ireland.49a8f609.png";